
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.14 9.946a.3.3 0 01-.28 0L2.492 6.04a.5.5 0 010-.883l7.038-3.733a1 1 0 01.938 0l7.038 3.733a.5.5 0 010 .883L10.14 9.946z","fill":"#999"}}),_c('path',{attrs:{"d":"M9.766 15.39l.234.124.234-.124 7.507-3.981a1 1 0 000-1.767l-.234.442.234-.442-7.038-3.733a1.5 1.5 0 00-1.406 0L2.26 9.642l.234.442-.234-.442a1 1 0 000 1.767l7.507 3.981zm-2.77-4.865L10 8.932l3.004 1.593L10 12.12l-3.004-1.594z","fill":"#999","stroke":"#fff"}}),_c('path',{attrs:{"d":"M13.076 16.554h0L10.67 19.2s0 0 0 0c-.364.4-.975.4-1.34 0l3.746-2.645zm0 0a.97.97 0 00.186-.992c-.113-.306-.406-.6-.837-.6h-1.127v-3.995c0-.47-.355-.942-.899-.942h-.798c-.544 0-.9.471-.9.942v3.995H7.575c-.431 0-.724.294-.838.6a.97.97 0 00.187.993s0 0 0 0l2.406 2.644 3.746-2.645z","fill":"#999","stroke":"#fff"}})])
          )
        }
      }
    